/*global kongData */
import { useState } from 'react';
import Button from './components/Button'
import './App.css';

function App() {
  const [clicks, setClicks] = useState(kongData.clicks || 0);
  const [mana, setMana] = useState(kongData.mana || 0);
  const [bonus, setBonus] = useState(kongData.bonus || 1);

  function onClick() {
    setClicks(clicks + 1)
    setMana(mana + bonus);
  }

  return (
    <div className="App">
      <div>Mana: {mana}</div>
      <div>Bonus per click: {bonus}</div>
      <Button
        show={true}
        text={`Clicks: ${clicks}`} 
        onClick={onClick} 
      />
    </div>
  );
}

export default App;
